import { catchError, firstValueFrom, from, of, throwError, timeout } from "rxjs";

import { CbwService } from "../../../../../apis/networkdashboard/rest/services";
import { CollectorCallbackParams } from "../collector-callback";

const SURF_ASNS = [1103, 1105];

export async function collectorAsn(
  cbw: CbwService,
  customerId: string,
  callback: (data: CollectorCallbackParams) => void,
) {
  const obs = from(cbw.getCustomerAsnList({ customer_id: customerId })).pipe(
    // make the operation time-out if this promise never resolves.
    // this can happen if the API throws an error (for authentication reasons, ...)
    timeout({
      first: 5_000,
      with: () => throwError(() => new Error("Operation timed out")),
    }),
    // catch the error (either timeout or the API error) and return an error string.
    // maybe also display something to the user?
    catchError((err) => {
      const { status, statusText } = err;
      return of(`(${status}) ${statusText}`);
    }),
  );

  const data = await firstValueFrom(obs);
  const callbackParams: CollectorCallbackParams = {
    data: "",
    error: undefined,
  };

  if (Array.isArray(data)) {
    callbackParams.data = data.filter((asn) => !SURF_ASNS.includes(asn)).join("\n");
  } else if (typeof data === "string") {
    // assume error
    callbackParams.error = new Error(data);
  }
  callback(callbackParams);
}
